/**
 * * code splitting
 *  This approach reduces the initial load time by loading the component only when it's needed.
 */
import { Spinner } from '@/components/Elements';
import { PublicLayout } from '@/components/Layout';
import ThankYou from '@/pages/onboarding/routes/ThankYou';
import { lazyImport } from '@/utils/lazyImport';
import path from 'path';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { HomeRoutes } from '@/pages/home';
/**
 * Dynamically imports the `OnboardingRoutes` component using the `lazyImport` function.
 *
 * This approach helps to:
 * - Improve application performance by reducing the initial bundle size.
 * - Load the `OnboardingRoutes` component only when it is actually needed,
 *   thereby enabling code splitting.
 */
const { OnboardingRoutes } = lazyImport(
  () => import('@/pages/onboarding'),
  'OnboardingRoutes',
);

const { SignUpRoutes } = lazyImport(
  () => import('@/pages/onboarding'),
  'SignUpRoutes',
);

const { ExternalAuthRoutes } = lazyImport(
  () => import('@/pages/external-auth'),
  'ExternalAuthRoutes',
);

const { BlueprintRoutes } = lazyImport(
  () => import('@/pages/blueprint'),
  'BlueprintRoutes',
);

const App = () => {
  return (
    <PublicLayout>
      <Suspense fallback={<Spinner />}>
        <Outlet />
      </Suspense>
    </PublicLayout>
  );
};
export const publicRoutes = [
  {
    path: '',
    element: <App />,
    children: [
      {
        path: '/',
        element: <HomeRoutes />,
      },
      {
        path: '/onboarding/*',
        element: <OnboardingRoutes />,
      },
      {
        path: '/sign-up/*',
        element: <SignUpRoutes />,
      },
      {
        path: ':id/thank-you',
        element: <ThankYou />,
      },
      {
        path: 'external-auth/*',
        element: <ExternalAuthRoutes />,
      },
      {
        path: 'blueprint/*',
        element: <BlueprintRoutes />,
      },
    ],
  },
];
